import React, { useState, useEffect } from 'react'
import { CardDrawer } from '../../../../../../../../../../components/Card'
import Buttons from '../../../../../../../../../../modules/Buttons'
import Button from '../../../../../../../../../../components/inputs/Button'
import Icon from '../../../../../../../../../../components/Icon'
import { StyledMonitorInfo, StyledMonitorText } from './styled';
import { useFetch } from '../../../../../../../../../../hooks';
import { isNil } from 'ramda'

function HeatMonitor({ rowid, heatMonitor, refetchCow }) {

    const { doFetch: doFetchHeatMonit } = useFetch({
        url: '/rpc/setheatmonit',
        method: 'POST'
    })

    const [isMonitorActive, toggleMonitor] = useState(heatMonitor.state);

    useEffect(() => {
        if(!isNil(heatMonitor.state)) {
            toggleMonitor(heatMonitor.state)
        } else {
            toggleMonitor(false)
        }
    }, [heatMonitor])

    const handleClickSetHeatMonit = async () => {
        try {
            await doFetchHeatMonit({
                data: {
                    rowid,
                    monitstart: isMonitorActive
                }
            })
            await refetchCow({ loader: false })
        } catch (err) {

        }
    }

    return (
        <CardDrawer
            name={heatMonitor.title}
            value={heatMonitor.info ? <StyledMonitorInfo active={heatMonitor.state}>{heatMonitor.info}</StyledMonitorInfo> : '----'}
            renderOpenButton={({ handleToggleIsOpenDrawer }) => <Button noMargin onClick={handleToggleIsOpenDrawer}><Icon name='edit' /></Button>}
            renderContentDrawer={({ handleToggleIsOpenDrawer }) => (
                <>
                    <Buttons>
                        <Button
                            type='button'
                            transparentGrey={isMonitorActive}
                            transparentGreen={!isMonitorActive}
                            noRadius
                            onClick={() => toggleMonitor(false)}
                        >
                            {heatMonitor.button[0]}
                        </Button>
                        <Button
                            type='button'
                            transparentGrey={!isMonitorActive}
                            transparentGreen={isMonitorActive}
                            noRadius
                            onClick={() => toggleMonitor(true)}
                        >
                            {heatMonitor.button[1]}
                        </Button>
                    </Buttons>
                    {heatMonitor.text && (
                        <StyledMonitorText>
                            <p>{heatMonitor.text[0]}</p>
                            <p>{heatMonitor.text[1]}</p>
                        </StyledMonitorText>
                    )}

                    <Buttons>
                        <Button
                            type='button'
                            onClick={handleToggleIsOpenDrawer}
                            width='50%'
                        >
                            {heatMonitor.buttons.cancel}
                        </Button>
                        <Button
                            type='button'
                            onClick={() => {
                                handleClickSetHeatMonit();
                                handleToggleIsOpenDrawer();
                            }}
                            width='50%'
                            green
                        >
                            {heatMonitor.buttons.save}
                        </Button>
                    </Buttons>
                </>
            )}
        />
    )
}

export default HeatMonitor
